import { State } from '../../types';

export const kansas: State = {
  name: 'Kansas',
  abbreviation: 'KS',
  terms: [
    {
      word: 'Arkansas River',
      phonetic: 'AR-kan-saw',
      // audioUrl: '/audio/arkansasriver.mp3',
      description: 'River flowing through Kansas'
    },
    {
      word: 'Chautauqua',
      phonetic: 'sha-TAW-kwuh',
      // audioUrl: '/audio/chautauqua.mp3',
      description: 'A county and city in Kansas, named after Chautauqua County, New York.'
    },
    {
      word: 'Neodesha',
      phonetic: 'nee-oh-duh-SHAY',
      // audioUrl: '/audio/neodesha.mp3',
      description: 'A city in Wilson County, with a name derived from the Osage language.'
    },
    {
      word: 'Osawatomie',
      phonetic: 'oh-suh-WAH-tuh-mee',
      // audioUrl: '/audio/osawatomie.mp3',
      description: 'A city named by combining the names of two Native American tribes: Osage and Pottawatomie.'
    },
    {
      word: 'Olathe',
      phonetic: 'oh-LAY-thuh',
      // audioUrl: '/audio/olathe.mp3',
      description: 'A city in Johnson County, with a name meaning "beautiful" in Shawnee.'
    },
    {
      word: 'Salina',
      phonetic: 'suh-LIE-nuh',
      // audioUrl: '/audio/salina.mp3',
      description: 'City in central Kansas'
    },
    {
      word: 'Schoenchen',
      phonetic: 'SHANE-chun',
      // audioUrl: '/audio/schoenchen.mp3',
      description: 'A city in Ellis County, with a name of Volga German origin.'
    },
    {
      word: 'Kiowa',
      phonetic: 'KAI-oh-wuh',
      // audioUrl: '/audio/kiowa.mp3',
      description: 'A city named after the Kiowa Native American tribe.'
    },
    {
      word: 'Iuka',
      phonetic: 'eye-YOU-kah',
      // audioUrl: '/audio/iuka.mp3',
      description: 'A city named after a battle in Mississippi, with a name derived from a Native American chief.'
    }
  ]
};